var components = {
  yiLoading: function () {
    return import(
      /* webpackChunkName: "components/yi-loading/yi-loading" */ "@/components/yi-loading/yi-loading.vue"
    )
  },
  uWaterfall: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-waterfall/u-waterfall" */ "uview-ui/components/u-waterfall/u-waterfall.vue"
    )
  },
  uLoadmore: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-loadmore/u-loadmore" */ "uview-ui/components/u-loadmore/u-loadmore.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }